import React, {useState} from "react";
import {useAuth} from "../contexts/AuthContext";
import {httpsCallable} from "firebase/functions";
import {functions} from "../firebase";
import "./School.css";

const products = [
  {id: "Premium360", name: "Premium 360 days", price: 99000, description: "프리미엄 라이선스 360일"},
  {id: "Premium270", name: "Premium 270 days", price: 77000, description: "프리미엄 라이선스 270일"},
  {id: "Premium180", name: "Premium 180 days", price: 55000, description: "프리미엄 라이선스 180일"},
  {id: "Premium90", name: "Premium 90 days", price: 33000, description: "프리미엄 라이선스 90일"},
  {id: "Premium30", name: "Premium 30 days", price: 22000, description: "프리미엄 라이선스 30일"}
];

export default function Payment() {
  const {currentUser} = useAuth();

  // //console.log(currentUser);

  const [isDownload, setDownload] = useState(false); // 이용약관 다운로드
  const [agreed, setAgreed] = useState(false); // 동의
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [selectedProduct, setSelectedProduct] = useState(products[0] || {});

  const [quantity, setQuantity] = useState("1");
  const [tax_free_amount, setTax] = useState("0");

  const handleTermsClick = () => {
    setDownload(true);
  };

  const handleProductSelect = (product) => {
    setSelectedProduct(product);
  };

  const handlePayment = async () => {
    if (!agreed) return;
    setLoading(true);
    setError("");

    try {
      //console.log("0----------");
      // 결제 준비 Cloud Function 호출
      const preparePayment = httpsCallable(functions, "preparePayment");
      //console.log("1----------");
      const result = await preparePayment({
        item_name: selectedProduct.name,
        quantity: quantity.toString(),
        total_amount: selectedProduct.price.toString(),
        tax_free_amount: tax_free_amount.toString(),
        user_id: currentUser.uid,
        product_id: selectedProduct.id,
        is_school: false
      });

      //console.log("2----------", result);

      // PC 환경인지 모바일 환경인지에 따라 적절한 URL로 리다이렉트
      const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
      if (isMobile) {
        //         //console.log("3----------");
        window.location.href = result.data.next_redirect_mobile_url;
      } else {
        //         //console.log("4----------");
        window.location.href = result.data.next_redirect_pc_url;
        //window.open(result.data.next_redirect_pc_url, '_blank', 'width=600,height=800');
      }
    } catch (error) {
      //       //console.log("5----------");
      console.log("5 error ----------", result);
      setError("결제 준비 중 오류가 발생했습니다: 고객센터로 문의바랍니다." + error.message);
    } finally {
      //       //console.log("6----------");
      setLoading(false);
    }
  };

  return (
    <section className="position-relative overflow-hidden pt-5 pt-lg-3">
      <div className="mx-auto g-4">
        <h2 className="text-2xl font-bold">라이선스 구매</h2>
        <div className="school-info border bg-bs-gray-600 px-4 py-2 mb-4 rounded">라이선스 기간별 구매할 제품을 선택하세요!</div>

        {error && <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4">{error}</div>}

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 mb-4">
          <div className="row g-4">
            {products.map(product => (

              <div key={product.id} className="col-sm-12 col-lg-6 col-xl-4">
                <div
                  className={`card border rounded p-2 my-1 cursor-pointer ${selectedProduct?.id === product.id ? "bg-warning" : "bg-white"}`}
                  onClick={() => handleProductSelect(product)}
                >
                  <h5 className="card-title fw-normal">{product.name}</h5>
                  <div className="card-body">{product.description}</div>
                  <div className="card-footer text-danger text-sm pt-0 pb-0">{product.price.toLocaleString()}원</div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="card-body bg-warning bg-gray-100 p-4 rounded mb-4">
          <h3 className="font-bold mb-2"><i className="fas fa-shopping-cart text-danger me-2"></i>선택한 제품 정보</h3>
          <p><strong>제품:</strong> {selectedProduct.name}</p>
          <p><strong>설명:</strong> {selectedProduct.description}</p>
          <p className="card-title fw-normal"><strong>가격:</strong> {selectedProduct.price.toLocaleString()}원</p>
          <h5><strong>계정:</strong> {currentUser.email}</h5>
        </div>


        <div className="bg-light border px-4 py-2 rounded mb-2 text-sm text-gray-700">
          <label className="flex items-start gap-2 mb-4">
            <div>
              결제하기를 누르면 학습데이터 서비스가 준비됩니다.
              따라서 결제 이후에는 취소할 수 없습니다.
            </div>
            <div>
              <a
                href="/documents/TermsofService.pdf"
                target="_blank"
                rel="noopener noreferrer"
                className="underline text-blue-600 hover:text-blue-800"
                onClick={handleTermsClick}
              >
              이용약관(TermsofService.pdf) 확인
              </a>
            </div>
            <input
              type="checkbox"
              checked={agreed}
              onChange={(e) => setAgreed(e.target.checked)}
              disabled={!isDownload}
              className="mt-1"
            /> &nbsp;
            <span>
              위 내용과 이용약관을 확인했으며, 이에 동의합니다.
            </span>
          </label>
        </div>

        <button
          className="btn-primary w-auto p-2 px-6 flex items-center gap-4"
          onClick={handlePayment}
          disabled={!agreed || loading}
        >
          {loading ? (
            "처리 중..."
          ) : (
            <>
              <img
                src="assets/images/pay/payment_icon_yellow_small.png"
                alt="카카오페이"
                className="w-5 h-5"
              />
              <span className="pl-4 gap-4"> 결제하기</span>
            </>
          )}
        </button>

        {error && <div className="bg-white border border-red-400 text-danger px-4 py-3 rounded mb-4">{error}</div>}

      </div>
    </section>
  );
}